import {
  GET_USERS_LIST_SUCCESS,
  GET_USERS_LIST_FAILURE,
  UPDATE_USER_STATUS,
  UPDATE_USER_STATUS_SUCCESS,
  UPDATE_USER_STATUS_FAILURE,
  ADD_ADMIN_ANALYST,
  ADD_ADMIN_ANALYST_SUCCESS,
  ADD_ADMIN_ANALYST_FAILURE,
  RESET_ADD_ADMIN_ANALYST_STATUS,
  DOWNLOAD_USERS_CSV,
  DOWNLOAD_USERS_CSV_SUCCESS,
  DOWNLOAD_USERS_CSV_FAILURE,

  VALIDATE_CORPORATE,
  VALIDATE_CORPORATE_SUCCESS,
  VALIDATE_CORPORATE_FAILURE
} from './action';

const initialState = {
  usersListSuccess: {
    admin: {},
    analyst: {},
    corporate: {}
  },
  usersListFailure: null,

  updateUserStatusSuccess: false,
  updateUserStatusFailure: null,

  addAdminAnalystSuccess: false,
  addAdminAnalystFailure: null,

  downloadingCSV: false,
  downloadCSVFailure: null,


  corporateValidationLoading: false,
  corporateValidationSuccess: null,
  corporateValidationFailure: null
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {

    /* ================= USERS LIST ================= */
    case GET_USERS_LIST_SUCCESS:
      return {
        ...state,
        usersListSuccess: {
          ...state.usersListSuccess,
          [action.payload.role]: action.payload.data
        },
        usersListFailure: null
      };

    case GET_USERS_LIST_FAILURE:
      return {
        ...state,
        usersListFailure: action.payload
      };

    /* ================= UPDATE STATUS ================= */
    case UPDATE_USER_STATUS:
      return {
        ...state,
        updateUserStatusFailure: null,
        updateUserStatusSuccess: false
      };

    case UPDATE_USER_STATUS_SUCCESS:
      return {
        ...state,
        updateUserStatusSuccess: true
      };

    case UPDATE_USER_STATUS_FAILURE:
      return {
        ...state,
        updateUserStatusFailure: action.payload,
        updateUserStatusSuccess: false
      };

    /* ================= ADD ADMIN / ANALYST ================= */

      case ADD_ADMIN_ANALYST:
        return {
          ...state,
          addAdminAnalystFailure: null,
          addAdminAnalystSuccess: false
        };

      case ADD_ADMIN_ANALYST_SUCCESS:
        return {
          ...state,
          addAdminAnalystFailure: null,
          addAdminAnalystSuccess: true
        };

      case ADD_ADMIN_ANALYST_FAILURE:
        return {
          ...state,
          addAdminAnalystFailure: action.payload,
          addAdminAnalystSuccess: false
        };

      case RESET_ADD_ADMIN_ANALYST_STATUS:
        return {
          ...state,
          addAdminAnalystSuccess: false,
          addAdminAnalystFailure: null
        };

    /* ================= DOWNLOAD CSV ================= */
    case DOWNLOAD_USERS_CSV:
      return {
        ...state,
        downloadingCSV: true,
        downloadCSVFailure: null
      };

    case DOWNLOAD_USERS_CSV_SUCCESS:
      return {
        ...state,
        downloadingCSV: false,
        downloadCSVFailure: null
      };

    case DOWNLOAD_USERS_CSV_FAILURE:
      return {
        ...state,
        downloadingCSV: false,
        downloadCSVFailure: action.payload
      };

      
     /* ================= CORPORATE VALIDATION ================= */
    case VALIDATE_CORPORATE:
      return {
        ...state,
        corporateValidationLoading: true,
        corporateValidationFailure: null,
        corporateValidationSuccess: null
      };

    case VALIDATE_CORPORATE_SUCCESS:
      return {
        ...state,
        corporateValidationLoading: false,
        corporateValidationSuccess: action.payload,
        corporateValidationFailure: null
      };

    case VALIDATE_CORPORATE_FAILURE:
      return {
        ...state,
        corporateValidationLoading: false,
        corporateValidationFailure: action.payload,
        corporateValidationSuccess: null
      };


    default:
      return state;
  }
};

export default usersReducer;
